<template>
    <div class="post-box" v-on:click="openLiveScore">
        <div class="post-content text-left">
            <h6 class="post-title">
                Diger Onerilerimiz
            </h6>
            <ul class="postBox-list">
                <li class="postBox-item casinoSidebar">
                    <router-link :to="{name: 'Casino'}">Casino</router-link>
                </li>
                <li class="postBox-item liveCasinoSidebar">
                    <router-link :to="{name: 'LiveCasino'}">Canli Casino</router-link>
                </li>
                <li class="postBox-item virtualSidebar">
                    <router-link :to="{name: 'Casíno'}">Sanal Spor</router-link>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'recommendedLinks',
        data () {
            return {
                msg: ''
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/sportsbook/widget/recommendedLinks.vue